// extracted by mini-css-extract-plugin
export default {"productGrid":"v1-z","centerLink":"w1-z","productSection":"x1-z","item":"y1-z","ctaButton":"z1-z"};